// extracted by mini-css-extract-plugin
export default {"numeric":"RecipientLimitDisplay_numeric__eAwTp"};